<div class="page-container">
  <div class="content-container content-container-md TeacherContactPage">
    <div class="pageHeading">{{ 'HELP_CENTER.HELP_CENTER' | translate }}</div>
    <br />

    <div class="row block_row">
      <div class="col-xs-12 col-sm-2 block_image">
        <kh-img class="mw-100" path="parent/circle-articles.png" alt="" localize="lang"></kh-img>
      </div>
      <div class="col-xs-12 col-sm-9 block_content">
          <h3 class="">{{ 'HELP_CENTER.SUPPORT_ARTICLES' | translate }}</h3>
            {{ 'HELP_CENTER.VISIT_OUR_ONLINE_HELPDESK' | translate }}<br />
          <a class="btn btn-sm btn-info" (click)="goToParentsExternalUrl()">{{ 'HELP_CENTER.VIEW_SUPPORT_ARTICLES' | translate }}</a>
      </div>
    </div>

    <!--<div class="row block_row">
    <div class="col-xs-12 col-sm-2 block_image">
      <img src="images/circle-live-support.png" />
    </div>
    <div class="col-xs-12 col-sm-9 block_content">
      <h3 class="">Live Chat</h3>
      Chat with a live support agent for immediate help or advice.<br />
      <button ng-click="LaunchChat()" class="manual_launcher btn btn-info btn-sm">Chat with us</button>
    </div>
  </div>-->

    <div class="row block_row">
      <div class="col-xs-12 col-sm-2 block_image">
        <kh-img path="parent/circle-airplane.png" alt="" localize="lang"></kh-img>
      </div>
      <div class="col-xs-12 col-sm-9 block_content">
       <br />
        <h3 class="">{{ 'HELP_CENTER.EMAIL_SUPPORT' | translate }}</h3>
          <ng-template #emailTpl>
            <a *ngIf="!isNativeApp" href="mailto:{{supportEmail}}">{{supportEmail}}</a><span *ngIf="isNativeApp">{{supportEmail}}</span>
          </ng-template>
          <span
            [translateWithFormat]="'HELP_CENTER.EMAIL_US_AT_PARTS.KH_MESSAGE_FORMAT'"
            [templateParams]="{ email: emailTpl }">
          </span>
        <br />
      </div>
    </div>
    <br>
  </div>
</div>

<!--<img class="ChatIconFloating" src="images/chat-button.png" ng-click="LaunchChat()" />-->
